import React from 'react';
import FormHelperText from '@material-ui/core/FormHelperText';

export default function FormValidationErrorMessage(props) {
  // console.log('Check Error Message ', props.errors[props.name]);

  if (!props.errors[props.name]) {
    return false;
  } else if (props.errors[props.name].ref.type === 'checkbox') {
    return (
      <FormHelperText error={true}>
        {props.errorMessagePrefix + ' Should be checked'}
      </FormHelperText>
    );
  } else if (
    props.errors[props.name].ref.type === 'number' &&
    props.errors[props.name].type === 'max'
  ) {
    return (
      <FormHelperText error={true}>
        {props.errorMessagePrefix +
          ' Should be minimum ' +
          props.errorMessageMinValue +
          ' and maximum ' +
          props.errorMessageMaxValue}
      </FormHelperText>
    );
  } else if (props.errors[props.name].ref.type === 'number') {
    return (
      <FormHelperText error={true}>
        {props.errorMessagePrefix + ' Should be greater than 0'}
      </FormHelperText>
    );
  } else {
    return (
      <FormHelperText error={true}>
        {props.errorMessagePrefix + ' is required'}
      </FormHelperText>
    );
  }
}
